module.exports = __webpack_public_path__ + "static/media/spoonerism-task (9).5c487e99.mp3";